import { styled } from 'styled-components';
import { TabsSectionWrapper } from '@template/components/Tabs/styles.ts';

export const Wrapper = styled.div<{ $altStyling?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  background: ${({ theme, $altStyling }) =>
    $altStyling
      ? `linear-gradient(to bottom, ${theme.colors.primary[950]} 200px, ${theme.colors.base} 0)`
      : theme.colors.base};
  position: relative;
  overflow: hidden;
  margin-bottom: 36px;

  > ${TabsSectionWrapper} {
    position: relative;
    z-index: 2;
    max-width: 1024px;
  }
`;
